import React from 'react';
import { Microscope, Gem, Users, Calendar } from 'lucide-react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ImagePlaceholder } from './ImagePlaceholder';
export function WhyUs() {
  const {
    ref,
    isVisible
  } = useFadeIn();
  const features = [{
    icon: <Microscope size={28} className="text-gold" data-id="element-388" />,
    title: 'Tecnología Digital',
    desc: 'Escáner intraoral y fresadora de precisión'
  }, {
    icon: <Gem size={28} className="text-gold" data-id="element-389" />,
    title: 'Materiales Premium',
    desc: 'Disilicato de litio, el más resistente'
  }, {
    icon: <Users size={28} className="text-gold" data-id="element-390" />,
    title: 'Dr. Nicolás y Equipo',
    desc: 'Especialistas certificados con amplia experiencia'
  }, {
    icon: <Calendar size={28} className="text-gold" data-id="element-391" />,
    title: 'Valoración Gratuita',
    desc: 'Tu diagnóstico inicial sin ningún costo'
  }];
  return <section id="nosotros" className="py-24 bg-primary relative overflow-hidden" data-id="element-392">
      {/* Background Image Placeholder */}
      <div className="absolute inset-0 opacity-10 pointer-events-none z-0" data-id="element-393">
        <ImagePlaceholder name="IMAGE 5 (clinic interior)" className="w-full h-full border-none !bg-transparent" data-id="element-394" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-395">
        <div ref={ref} className={`grid lg:grid-cols-2 gap-16 items-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-396">
          {/* Left Column */}
          <div data-id="element-397">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white mb-6 leading-tight" data-id="element-398">
              ¿Por qué somos la clínica #1 en Pereira?
            </h2>

            <p className="text-gray text-lg mb-10 leading-relaxed" data-id="element-399">
              Con más de 5 años transformando sonrisas en el Eje Cafetero,
              combinamos tecnología de punta con los mejores materiales del
              mercado para darte resultados que duran toda la vida.
            </p>

            {/* Doctor Profile Card */}
            <div className="bg-card/80 backdrop-blur-sm border border-border rounded-2xl p-6 flex flex-col sm:flex-row items-center sm:items-start gap-6 mb-8" data-id="element-400">
              <div className="w-24 h-24 rounded-full border-4 border-gold overflow-hidden flex-shrink-0 bg-primary" data-id="element-401">
                <img src="https://cdn.magicpatterns.com/uploads/g9LQYnKHo1XncJ38iRo4AY/5.jpg" alt="Dr. Nicolás - Especialista en Diseño de Sonrisa" className="w-full h-full object-cover" data-id="element-402" />
              </div>
              <div className="text-center sm:text-left" data-id="element-403">
                <h3 className="text-white font-bold text-xl mb-1" data-id="element-404">
                  Dr. Nicolás
                </h3>
                <p className="text-gold font-medium mb-3" data-id="element-405">
                  Especialista en Diseño de Sonrisa
                </p>
                <p className="text-gray italic text-sm" data-id="element-406">
                  "Nuestra misión es devolverte la confianza a través de tu
                  sonrisa"
                </p>
              </div>
            </div>

            <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-hover text-primary font-bold px-8 py-4 rounded-lg transition-colors w-full sm:w-auto" data-id="element-407">
              <span data-id="element-408">💬</span> Habla con Nosotros
            </a>
          </div>

          {/* Right Column - Features Grid */}
          <div className="grid sm:grid-cols-2 gap-6" data-id="element-409">
            {features.map((feature, idx) => <div key={idx} className="bg-card rounded-xl p-6 border border-border hover:border-gold/50 transition-colors" data-id="element-410">
                <div className="bg-primary w-14 h-14 rounded-lg flex items-center justify-center mb-4 border border-border" data-id="element-411">
                  {feature.icon}
                </div>
                <h4 className="text-white font-bold text-lg mb-2" data-id="element-412">
                  {feature.title}
                </h4>
                <p className="text-gray text-sm" data-id="element-413">{feature.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}